import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";

const trendData = [
  { month: "Apr", current: 52000, previous: 44000 },
  { month: "May", current: 58000, previous: 47000 },
  { month: "Jun", current: 54000, previous: 50000 },
  { month: "Jul", current: 61000, previous: 52000 },
  { month: "Aug", current: 63000, previous: 55000 },
  { month: "Sep", current: 59000, previous: 57000 },
  { month: "Oct", current: 65000, previous: 58000 },
  { month: "Nov", current: 68000, previous: 60000 },
  { month: "Dec", current: 72000, previous: 63000 },
  { month: "Jan", current: 64000, previous: 61000 },
  { month: "Feb", current: 69000, previous: 64000 },
  { month: "Mar", current: 67500, previous: 65000 },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload?.length) {
    return (
      <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-lg p-3 shadow-lg">
        <p className="text-xs font-semibold text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-2">{label}</p>
        {payload?.map((p) => (
          <div key={p?.dataKey} className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full" style={{ backgroundColor: p?.color }} />
            <span className="text-xs font-[var(--font-caption)] text-[var(--color-foreground)]">{p?.name}: </span>
            <span className="text-xs font-bold font-[var(--font-data)]" style={{ color: p?.color }}>${p?.value?.toLocaleString()}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export default function MonthlyTrendChart() {
  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl p-4 lg:p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-base lg:text-lg font-bold font-[var(--font-heading)] text-[var(--color-foreground)]">Monthly Revenue Trend</h3>
          <p className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)] mt-0.5">YoY comparison · Apr 2025 – Mar 2026</p>
        </div>
        <div className="flex items-center gap-1.5 px-2.5 py-1.5 bg-emerald-50 rounded-lg">
          <span className="text-xs font-bold text-emerald-700 font-[var(--font-data)]">+3.8%</span>
          <span className="text-xs text-emerald-600 font-[var(--font-caption)]">YoY</span>
        </div>
      </div>
      <div className="w-full h-48 lg:h-56" aria-label="Monthly Revenue Trend Line Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={trendData} margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" vertical={false} />
            <XAxis dataKey="month" tick={{ fontSize: 11, fill: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }} axisLine={false} tickLine={false} tickFormatter={(v) => `$${v / 1000}k`} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: "11px", fontFamily: "var(--font-caption)" }} />
            <Line type="monotone" dataKey="current" name="2025–26" stroke="#0F766E" strokeWidth={2.5} dot={false} activeDot={{ r: 5, fill: "#0F766E" }} />
            <Line type="monotone" dataKey="previous" name="2024–25" stroke="#94A3B8" strokeWidth={1.5} strokeDasharray="4 4" dot={false} activeDot={{ r: 4, fill: "#94A3B8" }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}